










































































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { validationMixin } from 'vuelidate';
import { required, email, maxLength } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { HealthcareProvider, OrgLocation } from '../../types/entity';
import { UploadFileResponse } from '@/types/response';
import { ApiRequest } from '@/types/request';
declare var google: any;

@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            status: '',
            address: {
                fullAddress: '',
                city: '',
                state: '',
                zip: '',
                landmark: '',
            },
            dropOffInstruction: '',
            pickupInstruction: '',
            billingLocationId: '',
            pickupInstructionImageUrl: '',
            dropoffInstructionImageUrl: '',
            pickupInstructionImgUploading: false,
            dropoffInstructionImgUploading: false,
            dropoffInstructionImageResourceId: '',
            pickupInstructionImageResourceId: '',
        };
    },
    validations() {
        const validations = {
            pickupInstruction: {
                maxLength: maxLength(100),
            },
            dropOffInstruction: {
                maxLength: maxLength(100),
            },
            fullName: {
                required,
            },
            billingLocationId: {
                required,
            },
            email: {
                email,
            },
            phone: {
                regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
            },
            address: {
                fullAddress: {
                    required,
                },
                state: {
                    required,
                },
                city: {
                    required,
                },
                zip: {
                    required,
                },
            },
        };
        if (this.$data.phone === '') {
            delete validations.phone.regex;
        }
        return validations;
    },
})
export default class UpdateHealthcareProviderModal extends Vue {
    private show = false;
    private providerGoogleAddress: any;
    private billingLocations: OrgLocation[] = [];
    private providerProfile: HealthcareProvider = {} as any;

    public mounted() {
        this.getProviderDetails(this.$route.params.id);
        this.getGoogleAddress();
        this.getBillingLocations();
    }

    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.providerGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('providerAddress1'), {
                types: ['geocode'],
            },
            );
            this.providerGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(
                    this.providerGoogleAddress,
                );
            });
        });
    }
    private async getProviderDetails(providerId: any) {
        const response = await ObjectFactory.getProviderService().getProviderDetails(this.$store.state.serverUrl,
            providerId);
        if (response.success && response.data) {
            this.providerProfile = response.data as HealthcareProvider;
            const provider = response.data;
            this.$data.fullName = provider.fullname;
            this.$data.email = provider.email;
            this.$data.phone = provider.phone;
            this.$data.status = provider.status;
            this.$data.address = provider.address ? provider.address : '';
            this.$data.dropOffInstruction = provider.dropOffInstruction;
            this.$data.pickupInstruction = provider.pickupInstruction;
            this.$data.billingLocationId = provider.billingLocationId;
            if (provider.pickupInstructionImageResourceId) {
                this.$data.pickupInstructionImageUrl =
                    await this.getResource(provider.pickupInstructionImageResourceId);
                this.$data.pickupInstructionImageResourceId = provider.pickupInstructionImageResourceId;
            }
            if (provider.dropoffInstructionImageResourceId) {
                this.$data.dropoffInstructionImageUrl =
                    await this.getResource(provider.dropoffInstructionImageResourceId);
                this.$data.dropoffInstructionImageResourceId = provider.dropoffInstructionImageResourceId;
            }
            this.show = true;
        } else {
            CommonUtils.showError(response);
        }
    }

    /**
     * @author <Shraddha.K>
     * @description - update provider
     * @param req {Request} - calls update provider API
     * @param res {Response} - Express Response - success result
     * @returns provider list
     * @throws InvalidRequestException if provider not found already exists
     */
    private async updateProvider() {
        const providerId = this.$route.params.id;
        const updateProviderRequest: HealthcareProvider = {
            fullname: this.$data.fullName,
            email: this.$data.email,
            phone: this.$data.phone,
            status: this.$data.status,
            address: this.$data.address,
            dropOffInstruction: this.$data.dropOffInstruction,
            pickupInstruction: this.$data.pickupInstruction,
            pickupInstructionImageResourceId: this.$data.pickupInstructionImageResourceId,
            dropoffInstructionImageResourceId: this.$data.dropoffInstructionImageResourceId,
        };
        if (this.$data.billingLocationId) {
            updateProviderRequest.billingLocationId = this.$data.billingLocationId;
        }
        const response = await ObjectFactory.getProviderService().updateProvider(this.$store.state.serverUrl,
            providerId, updateProviderRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_PROVIDER'),
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
            replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }


    private close() {
        this.$router.back();
    }

    private async getBillingLocations(): Promise<OrgLocation[]> {
        const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
        if (response.success && response.data) {
            this.billingLocations = response.data;
            return response.data;
        }
        return [];
    }

    private async uploadImage(type: string) {
        const fileInput = type === 'pickup' ? this.$refs.facilityPickupInstructionImgInput as HTMLInputElement
            : this.$refs.facilityDropoffIntructionImgInput as HTMLInputElement;
        this.$data.pickupInstructionImgUploading = type === 'pickup' ? true : false;
        this.$data.dropoffInstructionImgUploading = type === 'dropoff' ? true : false;
        if (fileInput && fileInput.files) {
            const file = fileInput.files[0];
            if (file) {
                const allowedExtensions = ['.jpg', '.jpeg', '.png'];
                const fileExtension = file.name.slice(Math.max(file.name.lastIndexOf('.') - 1, 0) + 2);
                if (allowedExtensions.includes('.' + fileExtension.toLowerCase())) {
                    const formData = new FormData();
                    formData.append('file', file);
                    try {
                        const iHttpService = ObjectFactory.getHttpService();
                        const apiRequest: ApiRequest = {
                            baseURL: this.$store.state.serverUrl,
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
                            data: formData,
                        };

                        const response = await iHttpService.post < UploadFileResponse > (apiRequest);
                        if (response.success && response.data) {
                            if (type === 'pickup') {
                                this.$data.pickupInstructionImageResourceId = response.data.fileName;
                            }
                            if (type === 'dropoff') {
                                this.$data.dropoffInstructionImageResourceId = response.data.fileName;
                            }
                            const toastEvent: ToastEvent = {
                                message: 'Image Uploaded Successfully',
                                title: 'Success',
                                varient: 'success',
                                timeout: 5000,
                            };
                            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                        }
                    } catch (error) {
                        const toastEvent: ToastEvent = {
                            message: 'Error while uploading Image',
                            title: 'Error',
                            varient: 'danger',
                            timeout: 5000,
                        };
                        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                    }
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        if (e.target && e.target.result) {
                            if (type === 'pickup') {
                                this.$data.pickupInstructionImgUploading = false;
                                this.$data.pickupInstructionImageUrl = e.target.result as string;
                            } else if (type === 'dropoff') {
                                this.$data.dropoffInstructionImgUploading = false;
                                this.$data.dropoffInstructionImageUrl = e.target.result as string;
                            }
                        }
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.$data.pickupInstructionImgUploading = false;
                    this.$data.dropoffInstructionImgUploading = false;
                    const toastEvent: ToastEvent = {
                        message: 'Enter Valid Picture',
                        title: 'Error',
                        varient: 'danger',
                        timeout: 5000,
                    };
                    EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                }
            }
        }
    }

    private async removeImage(type: string) {
        let resourceId = '';
        if (type === 'pickup') {
            resourceId = this.$data.pickupInstructionImageResourceId;
        }
        if (type === 'dropoff') {
            resourceId = this.$data.dropoffInstructionImageResourceId;
        }
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/${resourceId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.delete < string > (apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Image Removed Successfully',
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            const toastEvent: ToastEvent = {
                message: 'Error While Deleting Image.',
                title: 'Error',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        }
        if (type === 'pickup') {
            this.$data.pickupInstructionImageUrl = null;
            this.$data.pickupInstructionImageResourceId = null;
        }
        if (type === 'dropoff') {
            this.$data.dropoffInstructionImageUrl = null;
            this.$data.dropoffInstructionImageResourceId = null;
        }
    }

    private async getResource(resourceId: string): Promise<any> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/${resourceId}`,
        };
        const response = await iHttpService.get < any > (apiRequest);
        if (response.success && response.data) {
            return response.data;
        }
    }
}
